import { createContext, useContext } from "react";

export const KeycloakAuthContext = createContext({
  ready: true,
  keycloak: null,
  loginWithKeycloak: async (_options) => {},
  ensureAuthenticated: async (_options) => false,
});

export function useKeycloakAuth() {
  return useContext(KeycloakAuthContext);
}
